import { Card, Box, Typography, CardContent, Chip } from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import BackButton from "../bulk-operations/BackButton";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const ResultCards = ({
  totalRecords,
  searchType,
  totalFound,
  totalNotFound,
  totalFailed,
}) => {
  const uploadIdSession = sessionStorage.getItem("searchUploadId");
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Typography variant="h5" className="fw-bold _wg-dynamic-text d-flex">
          <BackButton buttonIcon="yes" backUrl="/bulk-search" /> Search Results
        </Typography>
        <Chip
          label={`Upload ID: ${uploadIdSession}`}
          sx={{
            backgroundColor: "#f0f9ff",
            borderColor: "#0ea5e9",
            color: "#0c4a6e",
            fontWeight: 600,
            border: "2px solid #0ea5e9",
            fontSize: "0.90rem",
            height: "auto",
            padding: "4px 8px",
            "& .MuiChip-label": {
              paddingLeft: "6px",
              paddingRight: "6px",
            },
          }}
          variant="outlined"
        />
      </Box>
      <Box className="d-flex justify-content-between mb-2">
        <Card variant="outlined" className="result-card-bulk-search">
          <CardContent className="d-flex justify-content-between bs-pading">
            <div className="d-flex flex-column gap-1">
              <Typography variant="body2" className="_wg-dynamic-text">
                Total {searchType === "advance" ? "Queries" : "Records"}
              </Typography>
              <Typography variant="body2" className="_wg-dynamic-text">
                {totalRecords}
              </Typography>
            </div>
            <div className="results-icon records-icon">
              <ArticleIcon fontSize="medium" />
            </div>
          </CardContent>
        </Card>
        <Card variant="outlined" className="result-card-bulk-search">
          <CardContent className="d-flex justify-content-between bs-pading">
            <div className="d-flex flex-column gap-1">
              <Typography variant="body2" className="_wg-dynamic-text">
                Found
              </Typography>
              <Typography variant="body2" className="_wg-dynamic-text">
                {totalFound}
              </Typography>
            </div>
            <div className="results-icon tick-icon">
              <CheckCircleOutlineIcon fontSize="medium" />
            </div>
          </CardContent>
        </Card>
        <Card variant="outlined" className="result-card-bulk-search">
          <CardContent className="d-flex justify-content-between bs-pading">
            <div className="d-flex flex-column gap-1">
              <Typography variant="body2" className="_wg-dynamic-text">
                Not Found
              </Typography>
              <Typography variant="body2" className="_wg-dynamic-text">
                {totalNotFound}
              </Typography>
            </div>
            <div className="results-icon warning-icon">
              <WarningAmberRoundedIcon fontSize="medium" />
            </div>
          </CardContent>
        </Card>
        <Card variant="outlined" className="result-card-bulk-search">
          <CardContent className="d-flex justify-content-between bs-pading">
            <div className="d-flex flex-column gap-1">
              <Typography variant="body2" className="_wg-dynamic-text">
                Failed
              </Typography>
              <Typography variant="body2" className="_wg-dynamic-text">
                {totalFailed}
              </Typography>
            </div>
            <div className="results-icon cross-icon">
              <HighlightOffIcon fontSize="medium" color="error" />
            </div>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default ResultCards;
